export default __webpack_public_path__ + "static/Spot opportunities and risks-88f91d053b05971db1ff338702831a32.png";